import { API, graphqlOperation } from "aws-amplify";
import {
  createCustomerReloadYardAccountMini,
  updateCustomerReloadYardAccountMini,
} from "../../../graphql/reloadyard/custom-mutations";
import { logError } from "../../../utils/appUtils";

export const sendEmails = async (reloadYardAccounts, generateEmailContent) => {
  try {
    if (
      typeof reloadYardAccounts === "object" &&
      !Array.isArray(reloadYardAccounts)
    ) {
      reloadYardAccounts = [reloadYardAccounts];
    }

    const promises = [];
    for (const record of reloadYardAccounts) {
      const emailContent = generateEmailContent(
        record.email,
        `${record.firstName} ${record.lastName}`,
        record.accountName || record.reloadYardName
      );

      const promise = API.post("transREST", "/sendEmail", {
        body: {
          to: record.email,
          bcc: ["support@transloads.co"],
          subject: "Customer User Deletion Notice",
          template: "emailTemplate.html",
          htmlContent: emailContent,
        },
      });
      promises.push(promise);
    }

    // Wait for all email sending promises to resolve
    await Promise.all(promises);
  } catch (error) {
    logError("managerApp:customers:customerUtils", error, false);
  }
};

export const doCreateReloadYardAccount = async (customer, acl, account, description) => {
  debugger;
  const toCreateRecord = {
    active: "true",
    groups: window.appUser.reloadYard.groups,
    customerId: customer.id,
    email: customer.email,
    lastName: customer.lastName,
    reloadYardId: window.appUser.reloadYardId,
    accountId: account.id,
    accountName: account.businessName,
    acl: acl,
    description: description || null,
  };

  await API.graphql(
    graphqlOperation(createCustomerReloadYardAccountMini, {
      input: toCreateRecord,
    })
  );
};

export const doUpdateReloadYardAccount = async (reloadYardAccount) => {
  debugger;
  const toUpdateRecord = { ...reloadYardAccount };

  delete toUpdateRecord.account;
  delete toUpdateRecord.createdAt;
  delete toUpdateRecord.customer;
  delete toUpdateRecord.reloadYard;
  delete toUpdateRecord.updatedAt;

  await API.graphql(
    graphqlOperation(updateCustomerReloadYardAccountMini, {
      input: toUpdateRecord,
    })
  );
};

export const deactivateReloadYardAccounts = (reloadYardAccounts) => {
  debugger;
  const promiseList = reloadYardAccounts.map((reloadYardAccount) => {
    const toUpdateRecord = { ...reloadYardAccount, active: "false" };
    delete toUpdateRecord.account;
    delete toUpdateRecord.createdAt;
    delete toUpdateRecord.customer;
    delete toUpdateRecord.reloadYard;
    delete toUpdateRecord.updatedAt;

    return API.graphql(
      graphqlOperation(updateCustomerReloadYardAccountMini, {
        input: toUpdateRecord,
      })
    );
  });

  return promiseList;
};
